import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import '../styles/Login.css';
import loginImage from '../assets/images/login-image.png';

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: ''    
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      // Llamar al servicio de autenticación
      const response = await authService.login(formData.username, formData.password);
      
      // Guardar datos del usuario para el header (compatible con el formato anterior)
      const userData = {
        username: response.usuario.username || formData.username,
        name: response.usuario.SOCIA_NOMBRE || response.usuario.socia_nombre || formData.username,
        role: response.usuario.permisos?.[0]?.PERMISO_NOMBRE || 'Usuario',
        email: response.usuario.SOCIA_EMAIL || response.usuario.socia_email || `${formData.username}@fepast.ec`,
        usuarioId: response.usuario.usuarioId,
        sociaId: response.usuario.sociaId,
        permisos: response.usuario.permisos
      };

      try {
        localStorage.setItem('currentUser', JSON.stringify(userData));
      } catch (err) {
        console.warn('No se pudo persistir currentUser:', err);
      }

      // Mostrar mensaje de bienvenida
      setSuccess(`¡Bienvenido/a ${userData.name}!`);
      
      // Esperar 1.5 segundos para que el usuario vea el mensaje de bienvenida
      setTimeout(() => {
        navigate('/dashboard');
      }, 1500);

    } catch (err) {
      console.error('Error en login:', err);
      setError(typeof err === 'string' ? err : 'Usuario o contraseña incorrectos');
      
      // Ocultar el mensaje de error y reactivar el botón después de 3 segundos
      setTimeout(() => {
        setError('');
        setLoading(false);
      }, 3000);
    }
  };

  return (
    <div className="login-container">
      {success && (
        <div style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: '#fff',
          padding: '30px 50px',
          borderRadius: '12px',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
          zIndex: 9999,
          textAlign: 'center',
          animation: 'fadeInScale 0.3s ease-out'
        }}>
          <div style={{
            fontSize: '48px',
            marginBottom: '15px',
            color: '#7B2869'
          }}>
            ✓
          </div>
          <h2 style={{
            color: '#7B2869',
            fontSize: '24px',
            margin: '0',
            fontWeight: '600'
          }}>
            {success}
          </h2>
        </div>
      )}

      {error && (
        <div style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: '#fff',
          padding: '30px 50px',
          borderRadius: '12px',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
          zIndex: 9999,
          textAlign: 'center',
          animation: 'fadeInScale 0.3s ease-out'
        }}>
          <div style={{
            fontSize: '48px',
            marginBottom: '15px',
            color: '#dc3545'
          }}>
            ✕
          </div>
          <h2 style={{
            color: '#721c24',
            fontSize: '20px',
            margin: '0',
            fontWeight: '600'
          }}>
            {error}
          </h2>
        </div>
      )}
      
      <div className="login-left-image">
        <img src={loginImage} alt="FEPAST" className="login-background-image" />
      </div>
      <div className="login-card">
        <div className="login-header">
          <h2>Iniciar Sesión</h2>
          <p>Accede al Sistema FEPAST</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Usuario</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Ingresa tu usuario"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Ingresa tu contraseña"
              required
            />
          </div>

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
